import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ClipboardSignature, Users, Heart, MessageCircle, Landmark } from "lucide-react";
import { PETITION_URL } from "../lib/constants";

const ACTIONS = [
    { icon: ClipboardSignature, label: "Sign The Petition", href: PETITION_URL, external: true, testid: "actionbar-petition" },
    { icon: Users, label: "Volunteer", to: "/contact", testid: "actionbar-volunteer" },
    { icon: Heart, label: "Donate", to: "/donate", testid: "actionbar-donate" },
    { icon: MessageCircle, label: "Share Your Story", to: "/contact", testid: "actionbar-share" },
    { icon: Landmark, label: "Contact Legislators", to: "/contact", testid: "actionbar-legislators" },
];

export const ActionBar = () => (
    <section className="bg-coral text-white relative overflow-hidden" data-testid="actionbar-section">
        {/* Animated red shimmer overlay */}
        <motion.div
            className="absolute inset-0 bg-gradient-to-r from-coral-dark via-coral to-coral-dark"
            initial={{ backgroundPosition: "-200% 0" }}
            animate={{ backgroundPosition: "200% 0" }}
            transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
            style={{ backgroundSize: "200% 100%" }}
        />
        <div className="relative max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-5 divide-x divide-white/20">
            {ACTIONS.map((a, i) => {
                const Tag = a.external ? "a" : Link;
                const props = a.external ? { href: a.href, target: "_blank", rel: "noopener noreferrer" } : { to: a.to };
                return (
                    <motion.div
                        key={a.label}
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: i * 0.08 }}
                        whileHover={{ scale: 1.05 }}
                    >
                        <Tag
                            {...props}
                            data-testid={a.testid}
                            className="group flex flex-col md:flex-row items-center justify-center gap-2 md:gap-3 py-8 md:py-10 px-4 text-center md:text-left hover:bg-white/10 transition-colors duration-300 h-full"
                        >
                            <motion.span
                                whileHover={{ rotate: -8, scale: 1.15 }}
                                transition={{ type: "spring", stiffness: 300 }}
                                className="inline-flex"
                            >
                                <a.icon className="w-7 h-7 md:w-8 md:h-8" strokeWidth={1.6} />
                            </motion.span>
                            <span className="font-sans uppercase tracking-[0.18em] text-[11px] md:text-xs font-semibold leading-snug">
                                {a.label}
                            </span>
                        </Tag>
                    </motion.div>
                );
            })}
        </div>
    </section>
);

export default ActionBar;
